import React, { Component } from 'react';
import DataTablesCreate from '../components/DataTablesCreate';
import '../css/dataTables.css';
import $ from 'jquery';
import { ApiClient } from "../libs/apiClient";
import config from "../config";
import StandardSelectModal from './StandardSelectModal';

let headers = [
    { title: 'Tipo pedido' },
    { title: 'Artículo' },
    { title: 'Cantidad' },
    { title: 'Fecha libreación' },
    { title: 'Fecha vencimiento' },
    { title: 'Proveedor' },
    { title: 'Nombre' },
    { title: 'De Almacén' },
    { title: 'A Almacén' }
];

let apiClient = ApiClient.getInstance();

class OrderRecommendation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            enable: false,
            checkboxArray: (new Map()),
            updateLine: -1,
            whsArray: [],
            showWhsModal: false,
            whsType: 0,
        };
        this.dataTable = null;
    }

    closeModal = async () => {
        $('#orderRecommendation').modal('hide');
    };

    search = async date => {
        const { newOrderModel, showAlert, enableSpinner } = this.props;
        let table = this.selectDocType(newOrderModel.SelectOf);

        let data = {
            dateInit: date.dateInit,
            dateFinal: date.dateFinal,
            docType: table.tableName,
            cardCode: newOrderModel.CardCode,
        };
        enableSpinner(true);
        let infoResponse = await apiClient.getDocuments(data);

        let dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };
        let seriesResponse = await apiClient.getSeries(dataSerie);

        let user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));

        let ValidateSeries = user[table.nameSeries] ? user[table.nameSeries] : "";

        if (!user || ValidateSeries === "") {
            showAlert({
                type: 'warning',
                timeOut: 5000,
                message: "Ocurrio un error en obtener las series permitidas para el usuario, intente reiniciar la sesión o contactar con su administrador"
            });
            enableSpinner(false);
            return;
        }

        let seriesUsers = ValidateSeries.split("|");
        let newArraySeries = [];

        for (const serieUser of seriesUsers) {
            for (const serieResponse of seriesResponse) {
                if (Number(serieResponse.Series) === Number(serieUser)) {
                    newArraySeries.push(serieResponse);
                }
            }
        }

        if (newArraySeries.length === 0) {
            showAlert({
                type: 'warning',
                timeOut: 5000,
                message: "El usuario no tiene serie permitida de escritura y lectura"
            });
            enableSpinner(false);
            return;
        }

        let newDocumentsfilterSeries = [];

        if (table.tableName === 'OWTQ') {
            for (let index = 0; index < infoResponse.data.length; index++) {
                const element = infoResponse.data[index];
                if (user.Warehouse === element.Filler) {
                    newDocumentsfilterSeries.push(element);
                }
            }
        } else {
            for (const document of infoResponse) {
                for (const serie of newArraySeries) {
                    if (document.Series === serie.Series && document.DocSubType === serie.DocSubType) {
                        newDocumentsfilterSeries.push(document);
                    }
                }
            }
        }

        enableSpinner(false);
        this.setState({
            data: newDocumentsfilterSeries,
            enable: false,
            checkboxArray: (new Map()),
        });
        setTimeout(() => {
            this.setState({
                enable: true
            })
        }, 20)

        setTimeout(() => {
            this.dataTable.refreshDates();
        }, 100)
    };

    selectDocType = table => {
        let docType = '';
        let docSubType = '';
        let nameSeries = '';
        let tableName = '';

        switch (table) {
            case 'PurchaseOrder':
                docType = '22';
                docSubType = '--';
                tableName = 'OPOR';
                nameSeries = 'U_FMB_ValidateSeriesOPOR';
                break;
            case 'transfersRequest':
                docType = "1250000001";
                docSubType = "--";
                tableName = "OWTQ";
                nameSeries = "U_FMB_ValidateSeriesOWTQ";
                break;
            default:
                docType = '';
                table = '';
                docSubType = '';
                break;
        }
        return { docType, docSubType, nameSeries, tableName }
    };

    selectDocuments = checkboxArray => {
        this.setState({ checkboxArray });
    };

    getDestination = key => {
        let name = '';
        let originDoc = '';
        let complement = '';
        let docSubType = '';
        let docType = '';

        switch (key) {
            case 'P':
                name = 'OPOR'; // Orden de compra
                originDoc = 'PurchaseOrder';
                complement = "POR1";
                docSubType = "--";
                docType = "22";
                break;
            case 'Q':
                name = 'OPQT'; // Cotización de compra
                originDoc = 'PurchaseQuotation';
                complement = "PQT1";
                docSubType = "--";
                docType = "540000006";
                break;
            case 'R':
                name = 'OPRQ'; // Solicitud de compra
                originDoc = 'PurchaseRequest';
                complement = "PRQ1";
                docSubType = "--";
                docType = "1470000113";
                break;
            case 'T':
                name = 'OWTQ'; // Solicitud de transferencia de inventario
                originDoc = 'transfersRequest';
                complement = "WTQ1";
                docSubType = "--";
                docType = "1250000001";
                break;
            case 'W':
                name = 'OWOR'; // Orden de producción
                originDoc = 'ProductionOrder';
                complement = "WOR1";
                docSubType = "--";
                docType = "202";
                break;
            default:
                break;
        }
        return { name, originDoc, complement, docSubType, docType }
    }

    selectValidateSeries = (table, data) => {
        switch (table) {
            case 'OPOR': return data.U_FMB_ValidateSeriesOPOR || "";
            case 'OPRQ': return data.U_FMB_ValidateSeriesOPRQ || "";
            case 'OWTQ': return data.U_FMB_ValidateSeriesOWTQ || "";
            default: return "";
        }
    };

    selectDocumentsToArray = async () => {
        const { newOrderModel, enableSpinner, data, showDocs } = this.props;
        const { checkboxArray } = this.state;
        let linesSelected = [];

        for (let [id, value] of checkboxArray.entries()) {
            if (value) {
                linesSelected.push(data[id]);
            }
        }

        const user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')) || {};
        enableSpinner(true);
        let seriesResponse = await apiClient.getSeries();
        enableSpinner(false);

        if (seriesResponse.status) { seriesResponse = seriesResponse.data || []; }
        else { seriesResponse = []; }

        let modelsToSend = []
        for (let index = 0; index < linesSelected.length; index++) {
            const line = linesSelected[index];
            const destination = this.getDestination(line.OrderType)
            let currOrderModel = { ...newOrderModel }
            currOrderModel.Comments = 'Origen PNM - BRANCH'
            currOrderModel.CardCode = line.CardCode
            currOrderModel.CardName = line.CardName
            currOrderModel.OriginDocumentCreate = destination.originDoc
            currOrderModel.UserID = user.USERID;
            currOrderModel.Requester = user.USER_CODE || '';
            currOrderModel.ReqName = user.U_NAME || '';
            currOrderModel.Email = user.E_Mail || '';
            currOrderModel.Branch = user.Branch.IdBranch || '';
            currOrderModel.BranchName = user.Sucursal || '';

            // Traslados
            currOrderModel.Filler = line.FromWhse || '';
            currOrderModel.ToWhsCode = line.Warehouse || '';

            let ValidateSeries = this.selectValidateSeries(destination.name, user);
            let seriesUsers = ValidateSeries.split("|");
            let newArraySeries = [];

            for (const serieUser of seriesUsers) {
                for (const serieResponse of seriesResponse) {
                    if (Number(serieResponse.Series) === Number(serieUser) && serieResponse.DocSubType === destination.docSubType) {
                        newArraySeries.push(serieResponse);
                    }
                }
            }

            if (seriesUsers.length > 0) {
                currOrderModel.SerieCode = seriesUsers[0].Series || '';
                currOrderModel.SerieName = seriesUsers[0].SeriesName || '';
            }

            let items = [{
                ItemCode: line.ItemCode,
                ItemName: line.ItemName,
                Description: line.ItemName,
                Quantity: Number(line.Quantity),
                WhsCode: line.Warehouse || '',
                WhsName: '',
                AcctCode: user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctCode : '',
                AcctCode2: user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctCode2 : '',
                AcctCodeName: user.Branch.AccountDefault ? user.Branch.AccountDefault[0].AcctName : '',
                FormatCode: user.Branch.AccountDefault ? user.Branch.AccountDefault[0].FormatCode : '',
                FormatCode2: user.Branch.AccountDefault ? user.Branch.AccountDefault[0].FormatCode2 : '',
                BatchNumbers: []
            }]

            currOrderModel.Items = items;
            modelsToSend.push({ document: currOrderModel, line });
        }
        $('#orderRecommendation').modal('hide');
        await showDocs(modelsToSend);
    };

    openWhsModal = async (index, type) => {
        const { enableSpinner } = this.props;
        enableSpinner(true);
        let whsArray = await apiClient.getSuggestionCatalogs({ whs: true });
        enableSpinner(false);
        if (whsArray.status) { whsArray = whsArray.data.warehouses || []; }
        else { whsArray = []; }

        await this.setState({
            updateLine: index,
            whsType: type,
            whsArray,
            showWhsModal: true,
        });

        $("#selectWhsModal").modal("show");
        $("#selectWhsModal").on("hidden.bs.modal", async () => {
            await this.setState({
                updateLine: -1,
                whsType: 0,
                whsArray: [],
                showWhsModal: false,
            });
        });
    }

    selectWhs = async (whs) => {
        const { refreshData } = this.props;
        const { updateLine, whsType } = this.state;
        if (updateLine === -1 || !whsType) return;
        await refreshData(updateLine, whsType === 1 ? "FromWhse" : "Warehouse", whs.WhsCode)
        $("#selectWhsModal").modal("hide");
    }

    render() {
        const {
            data,
            view,
            newOrderModel,
            showAlert,
            refreshData,
        } = this.props;

        const {
            whsArray,
            showWhsModal,
        } = this.state;

        return (
            <div className="modal fade bd-example-modal-lg scroll bgtransparent" id="orderRecommendation" style={{ zIndex: 91 }}
                role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                <div className="modal-dialog modal-xl " role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                            style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                            <h4 className="modal-title" id="modal-basic-title"> Recomendación de pedido </h4>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span className="text-white" aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ maxHeight: 650 }}>
                            <div className="row">
                                <div className="col-12">
                                    {data.length > 0 &&
                                        <DataTablesCreate
                                            data={data}
                                            headers={headers}
                                            view={"orderRecommendation"}
                                            originalView={view}
                                            flagInvoices={(!!newOrderModel.SelectOf && newOrderModel.SelectOf === "invoice")}
                                            showAlert={showAlert}
                                            ref={(ref) => this.dataTable = ref}
                                            action={this.selectDocuments}
                                            search={this.search}
                                            refreshData={refreshData}
                                            openWhsModal={this.openWhsModal} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn botonCerrar text-white"
                                onClick={this.closeModal}>Cerrar
                            </button>
                            <button type="button" className="btn botonCorrect"
                                onClick={this.selectDocumentsToArray}>Actualizar
                            </button>
                        </div>
                    </div>
                </div>


                {showWhsModal &&
                    <StandardSelectModal
                        id="selectWhsModal"
                        title="Previsiones"
                        data={whsArray}
                        selectAction={this.selectWhs}

                        headers={[
                            { title: "Código", value: true, filter: true, field: "WhsCode", format: null, classes: "text-left" },
                            { title: "Almacén", value: true, filter: true, field: "WhsName", format: null, classes: "text-left" },
                        ]}

                        actPos="start" />
                }
            </div>
        );
    }
}

export default OrderRecommendation;